<template>
  <b-dropdown no-caret variant="transparent" right>
    <template #button-content>
      <b-icon class="kebab" icon="three-dots"></b-icon>
    </template>
    <b-dropdown-item
      class="pr-0"
      v-show="file && file.user.is_subscribed"
      @click="pinFile"
    >
      <b-img :src="require('@/assets/icons/pin.svg')" class="pin mr-2"></b-img>
      <span>{{ isPinned ? 'Unpin' : 'Pin' }}</span> </b-dropdown-item
    ><b-dropdown-divider
      v-show="file && file.user.is_subscribed"
    ></b-dropdown-divider>
    <b-dropdown-item class="p-0" @click="editFile">
      <b-icon icon="pencil-square" font-scale="0.95" class="mr-3"></b-icon>
      <span>Edit</span> </b-dropdown-item
    ><b-dropdown-divider></b-dropdown-divider>
    <b-dropdown-item class="p-0" @click="downloadFile">
      <b-icon icon="download" font-scale="0.95" class="mr-3"></b-icon>
      <span>Download</span> </b-dropdown-item
    ><b-dropdown-divider></b-dropdown-divider>
    <b-dropdown-item class="p-0" @click="showDelFiles">
      <b-icon icon="trash" font-scale="0.95" class="mr-3"></b-icon>
      <span>Delete</span> </b-dropdown-item
    ><b-dropdown-divider v-show="isShareable" />
    <b-dropdown-item v-show="isShareable" class="p-0" @click="shareFile">
      <b-icon icon="cursor" font-scale="0.95" class="mr-3"></b-icon>
      <span>Share</span>
    </b-dropdown-item>
    <b-modal
      centered
      v-model="delModalShow"
      id="delete-file-modal"
      title="Delete selected file?"
    >
      <p class="my-4">
        Are you sure you want to delete the selected file?
      </p>

      <template #modal-footer>
        <b-button variant="secondary" @click="cancelDelFiles()">
          No
        </b-button>
        <b-button variant="primary" @click="deleteFile()">
          Yes
        </b-button>
      </template>
    </b-modal>
  </b-dropdown>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  props: {
    file: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      isPinned: this.file.is_pinned,
      delModalShow: false
    }
  },

  computed: {
    isShareable() {
      return (
        this.file.status === 'valid' ||
        this.file.status === 'not started' ||
        this.file.status === 'expiring soon'
      )
    }
  },

  methods: {
    ...mapActions({
      getFile: 'file/getFile'
    }),

    async editFile() {
      await this.getFile(this.file.id)
      this.$router.replace({
        name: 'file.edit-page',
        params: { id: this.file.id }
      })
    },

    async pinFile() {
      if (this.isPinned) {
        await this.$api.post(`file/${this.file.id}/unpin`).then(({ data }) => {
          if (data.success) {
            this.isPinned = false
            this.$emit('showAlert', 'unpinned')
          }
        })
      } else {
        await this.$api.post(`file/${this.file.id}/pin`).then(({ data }) => {
          if (data.success) {
            this.isPinned = true
            this.$emit('showAlert', 'pinned')
          }
        })
      }
    },
    async deleteFile() {
      await this.$api.delete(`file/${this.file.id}`).then(({ data }) => {
        if (data.success) {
          this.cancelDelFiles()
          this.$emit('showAlert', 'deleted')
        }
      })
    },
    async downloadFile() {
      await this.$api
        .get(`download-file/${this.file.id}`, {
          responseType: 'blob'
        })
        .then(data => {
          const name = this.file.user.full_name
          const filename = `${name} - ${this.file.name}.zip`
          const url = URL.createObjectURL(
            new Blob([data.data], {
              type: 'application/zip'
            })
          )
          const link = document.createElement('a')

          link.href = url
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()

          this.$emit('showAlert', 'downloaded successfully.')
        })
        .catch(e => {
          setTimeout(e => {
            this.$emit('showAlert', 'downloaded unsuccessfully.')
          }, 5000)
        })
    },
    showDelFiles() {
      this.delModalShow = true
    },
    cancelDelFiles() {
      this.delModalShow = false
    },
    shareFile() {
      this.$emit('shareFile')
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .dropdown-menu {
  top: -15px !important;
  left: -20px !important;
}
.pin {
  width: 23px;
  height: 23px;
}
</style>
